import './Hero.scss';


export default function Hero({ children }) {

  return (
    <div className="hero">
      {children}
    </div>
  );
}

export function Title({ children }) {
  return (
    <h2 className="hero-title">
      {children}
    </h2>
  );
}
export function Description({ children }) {
  return (
    <p className="hero-description">
      {children}
    </p>
  );
}
